import { useState } from "react";
import ReactApexChart from "react-apexcharts";

export function UtilMeter({ title, subtitle, credit, refund, spent, utitPer ,className=""}) {
 
  const [isDark] = useState(localStorage.getItem("theme") === "dark");

  const options = {
    chart: {
      type: "radialBar",
      offsetY: -10,
      sparkline: { enabled: true },
    },

    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        hollow: {
          margin: 0,
          size: "75%",
        },

        track: {
          background: isDark ? "#e7ebe6" : "#001321", // light vs dark

          strokeWidth: "70%",
        },

        dataLabels: {
          name: { show: false },
          value: {
            offsetY: -5,
            fontSize: "32px",
            fontWeight: 700,
            color: isDark ? "#e7ebe6" : "#001321", // light vs dark

            formatter: (val) => `${val}%`,
          },
        },
      },
    },

    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        gradientToColors: ["#6C5CE7"],
        stops: [0, 100],
      },
    },

    stroke: {
      lineCap: "round",
    },
  };

  return (
    <div className={`h-full bg-white dark:bg-slate-900/90 p-1 rounded-2xl shadow-md w-full ${className}`}>
      <div className="bg-slate-400/20 dark:bg-slate-800/50 rounded-2xl px-4 py-3 flex flex-col items-start justify-center">
        <span className="text-[13px] font-semibold  text-slate-700 dark:text-slate-200">
          {title}
        </span>
        <span className="text-xs font-normal  text-slate-700 dark:text-slate-400">
          {subtitle}
        </span>

        <div className="  flex items-center justify-center mt-6 w-full">
          <ReactApexChart
            options={options}
            series={[utitPer]}
            type={"radialBar"}
            height={250}
            // width={300}
          />
        </div>
      </div>

      <div className="flex justify-around text-center mt-4 text-gray-600">
        <div className="space-y-2">
          <p className="text-xs font-medium font-sans text-slate-600 dark:text-slate-200">
            Credited
          </p>
          <p className="text-[13px] font-semibold text-slate-600 dark:text-slate-100">
            {credit}
          </p>
        </div>
        <div className="border-l border-gray-300 h-8"></div>
        <div className="space-y-2"> 
          <p className="text-xs font-medium font-sans text-slate-600 dark:text-slate-200">
            Spent
          </p>
          <p className="text-[13px] font-semibold text-slate-600 dark:text-slate-100">
            {spent}
          </p>
        </div>
        <div className="border-l border-gray-300 h-8"></div>
        <div className="space-y-2">
          <p className="text-xs font-medium font-sans text-slate-600 dark:text-slate-200">
            Refunded
          </p>
          <p className="text-[13px] font-semibold text-slate-600 dark:text-slate-100">
            {refund}
          </p>
        </div>
      </div>
    </div>
  );
}
